@if (serverError(); as serverError) {
	<error-page [status]="serverError" (logout)="logout()"></error-page>
} @else {
	<router-outlet></router-outlet>
}
